(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ConstantsService', ConstantsService);

    ConstantsService.$inject = ['$rootScope', '$http'];

    function ConstantsService($rootScope, $http) {
        var service = {
            set: set,
            get: get,
            saveBanner: saveBanner,
            getBanner: getBanner,
            deleteBanner: deleteBanner,
            isBannerActive: isBannerActive
        };

        return service;

        function set(interval) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxConstants/set',
                data: interval
            });
        }

        function get(constantName) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxConstants/search/findByName',
                params: { name: constantName }
            });
        }

        function saveBanner(bannerDto) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/communique',
                data: bannerDto
            });
        }

        function getBanner() {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/communique'
            });
        }

        function deleteBanner() {
            return $http({
                method: 'DELETE',
                url: $rootScope.API_URL + 'api/communique'
            });
        }

        function isBannerActive() {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/communique/isActive'
            });
        }

    }
})();
